import React, { useState, useEffect } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import EmbedFormLogoUploader from "components/Reusable/EmbedFormLogoUploader/EmbedFormLogoUploader.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import getAsyncImage from "utils/getAsyncImage";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";
import { useToasts } from "react-toast-notifications";
import { defaultFormImages } from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import { useUser } from "contexts/userContext/userContext.js";

const MAX_LIMIT_TITLE = 30;
const MAX_LIMIT_DESCRIPTION = 150;

const FormDetailsComponent = ({
  setFormDisplayTitle,
  formDisplayTitle,
  setFormDescription,
  formDescription,
  EmbedDynamicId,
  setFormImage,
  formImage,
  showImage,
  setShowImage,
  showDescription,
  setShowDescription,
  showTitle,
  setShowTitle,
  invalidDescription,
  setInvalidDescription,
  invalidTitleForm,
  setInvalidTitleForm,
  updateBeforeSave,
  setUpdateBeforeSave,
  errorTitleText,
  setErrorTitleText,
}) => {
  const { getTextByKey, getDirection } = useContent();
  const { setModal } = useModal();
  const { addToast } = useToasts();
  const { isPremium, isSubscribed } = useUser();
  const [errorDescriptionText, setErrorDescriptionText] = useState("");
  //Title:
  const [focusTitle, setFocusTitle] = useState(false);
  const [blurTitle, setBlurTitle] = useState(false);
  // const [isPastedText, setIsPastedText] = useState(false);

  useEffect(() => {
    if (blurTitle) {
      if (!formDisplayTitle) {
        setErrorTitleText(getTextByKey("form-name-required"));
        setInvalidTitleForm(true);
      } else if (formDisplayTitle.length > MAX_LIMIT_TITLE) {
        setErrorTitleText(getTextByKey("validate-form-name"));
        setInvalidTitleForm(true);
      } else {
        setUpdateBeforeSave({ mode: true, action: "updateTitle" });
        setInvalidTitleForm(false);
        setErrorTitleText("");
      }
      setBlurTitle(false);
    }
  }, [blurTitle, formDisplayTitle]);

  const hideEmbedFormTitle = () => {
    if (EmbedDynamicId > 0) {
      //updateHideEmbedFormTitle();
      setShowTitle((prev) => !prev);
      setUpdateBeforeSave({
        mode: true,
        action: "updateHideEmbedFormTitle",
        heightChanged: true,
      });
    } else {
      // addToast(getTextByKey("before-save-form"), {
      //   appearance: "error",
      // });
    }
  };

  const handleChangeTitleForm = (value) => {
    if (!value) {
      setFormDisplayTitle("");
      setInvalidTitleForm(true);
    } else {
      const truncatedValue = value.slice(0, MAX_LIMIT_TITLE);
      setFormDisplayTitle(truncatedValue);
      if (truncatedValue.length < MAX_LIMIT_TITLE) {
        setInvalidTitleForm(false);
      }
    }
  };

  // const updateHideEmbedFormTitle = async () => {
  //   const body = {
  //     Embed_Dynamic_Hide_Title: !showTitle,
  //     Embed_Dynamic_Id: EmbedDynamicId,
  //   };
  //   const response = await apiRequest(
  //     "EmbedDynamics",
  //     "UpdateHideEmbedDynamicFormTitle",
  //     body,
  //     "POST"
  //   );
  //   if (response.status === "success") {
  //     if (response.data === 0) {
  //       setUpdateBeforeSave({
  //         mode: true,
  //         action: "UpdateHideEmbedDynamicFormTitle",
  //       });
  //     }
  //   }
  // };

  //Descirption:
  const [focusDescription, setFocusDescription] = useState(null);
  const [blurDescription, setBlurDescription] = useState(null);

  useEffect(() => {
    if (blurDescription) {
      if (!formDisplayTitle) {
        setInvalidTitleForm(true);
        setErrorTitleText(getTextByKey("form-name-required"));
        addToast(getTextByKey("form-name-required"), {
          appearance: "error",
        });

        setInvalidDescription(false);
        setErrorDescriptionText("");
      } else if (!formDescription) {
        setFormDescription("");
        setInvalidDescription(false);
        setErrorDescriptionText("");
      } else if (formDescription.length > MAX_LIMIT_DESCRIPTION) {
        setErrorDescriptionText(
          `${getTextByKey("character-limit-exceeded")} ${MAX_LIMIT_DESCRIPTION}`
        );
        setInvalidDescription(true);
        addToast(getTextByKey("validate-form-description"), {
          appearance: "error",
        });
      } else {
        setInvalidDescription(false);
        setErrorDescriptionText("");
      }
      setBlurDescription(false);
    }
  }, [blurDescription, formDescription, formDisplayTitle]);

  // const updateHideEmbedFormDescription = async () => {
  //   const body = {
  //     Embed_Dynamic_Hide_Description: !showDescription,
  //     Embed_Dynamic_Id: EmbedDynamicId,
  //   };
  //   const response = await apiRequest(
  //     "EmbedDynamics",
  //     "UpdateHideEmbedDynamicFormDescription",
  //     body,
  //     "POST"
  //   );
  //   if (response.status === "success") {
  //     if (response.data === 0) {
  //       setUpdateBeforeSave({
  //         mode: true,
  //         action: "UpdateHideEmbedDynamicFormDescription",
  //       });
  //     }
  //   }
  // };

  const hideEmbedFormDescription = () => {
    if (EmbedDynamicId > 0) {
      //updateHideEmbedFormDescription();
      setShowDescription((prev) => !prev);
      setUpdateBeforeSave({
        mode: true,
        action: "updateHideEmbedFormDescription",
        heightChanged: true,
      });
    } else {
      // addToast(getTextByKey("before-save-form"), {
      //   appearance: "error",
      // });
    }
  };

  const handleChangeDescription = (value) => {
    if (!value) {
      setFormDescription("");
      setInvalidDescription(false);
    } else {
      const truncatedValue = value.slice(0, MAX_LIMIT_DESCRIPTION);
      setFormDescription(truncatedValue);
      if (truncatedValue.length < MAX_LIMIT_DESCRIPTION) {
        setInvalidDescription(false);
      }
    }
  };

  const handlePasteText = (e, currentValue, maxLimit, onChange, type) => {
    const pastedText = e.clipboardData.getData("text");
    const remainingSpace = maxLimit - currentValue.length;

    const newValue = pastedText.slice(0, remainingSpace);

    onChange(currentValue + newValue);

    if (currentValue.length + pastedText.length > maxLimit) {
      if (type === "title") {
        setInvalidTitleForm(true);
        setErrorTitleText(
          `${getTextByKey("character-limit-exceeded")} ${maxLimit}`
        );
      }
      if (type === "description") {
        setInvalidDescription(true);
        setErrorDescriptionText(
          `${getTextByKey("character-limit-exceeded")} ${maxLimit}`
        );
      }
    }
  };
  console.log("!!!", invalidDescription);
  const handleTitlePaste = (e) => {
    handlePasteText(
      e,
      formDisplayTitle,
      MAX_LIMIT_TITLE,
      handleChangeTitleForm,
      "title"
    );
  };

  const handleDescriptionPaste = (e) => {
    handlePasteText(
      e,
      formDescription,
      MAX_LIMIT_DESCRIPTION,
      handleChangeDescription,
      "description"
    );
  };

  const removeImageApi = async () => {
    const parameters = {
      embedDynamicId: EmbedDynamicId,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "DeleteEmbedFormLogo",
      parameters
    );
    if (response.status === "success") {
      if (response.data === 0) {
        let randNum = Math.floor(Math.random() * 18);
        getAsyncImage(
          `images/${defaultFormImages[randNum]}.webp`,
          setFormImage
        );
        setUpdateBeforeSave({
          mode: true,
          action: "RemoveEmbedDynamicFormImage",
        });
      }
    }
  };

  //Image:
  const openUploadImageModal = () => {
    if (isSubscribed()) {
      if (EmbedDynamicId && EmbedDynamicId > 0) {
        setModal(() => (
          <EmbedFormLogoUploader
            formId={EmbedDynamicId}
            logoImage={formImage}
            setLogoImage={setFormImage}
            removeImageApi={removeImageApi}
          />
        ));
      } else {
        setUpdateBeforeSave({ mode: true, action: "uploadImage" });
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const hideEmbedFormImage = () => {
    if (EmbedDynamicId > 0) {
      //updateHideEmbedFormImage();
      setShowImage((prev) => !prev);
      setUpdateBeforeSave({
        mode: true,
        action: "updateHideEmbedFormImage",
        heightChanged: true,
      });
    } else {
      // addToast(getTextByKey("before-save-form"), {
      //   appearance: "error",
      // });
    }
  };

  // const updateHideEmbedFormImage = async () => {
  //   const body = {
  //     Embed_Dynamic_Hide_Image: !showImage,
  //     Embed_Dynamic_Id: EmbedDynamicId,
  //   };
  //   const response = await apiRequest(
  //     "EmbedDynamics",
  //     "UpdateHideEmbedDynamicFormImage",
  //     body,
  //     "POST"
  //   );
  //   if (response.status === "success") {
  //     if (response.data === 0) {
  //       setUpdateBeforeSave({
  //         mode: true,
  //         action: "UpdateHideEmbedDynamicFormImage",
  //       });
  //     }
  //   }
  // };

  return (
    <div className="edit-form-details">
      <div className="form-details-title">
        <h1>{getTextByKey("form-details")}</h1>
        <div className="subtitle">
          <p>{getTextByKey("create-form-subtitle")}</p>
        </div>
      </div>
      <div className="form-details-inputs">
        <div className="div-input-title">
          <div className="div-text">
            <div className="tooltip-div">
              <label for="form-title-input" className="text-span">
                {getTextByKey("create-form-name")}
              </label>
              <Tooltip
                id={"form-title-tooltip"}
                tooltipTextKey="form-title-tooltip"
                //hardPositioned
              >
                <Icon name="question-circle" iconClass="tooltip-question" />
              </Tooltip>
            </div>
            <div className="toggle-div">
              <Toggle status={showTitle} setStatus={hideEmbedFormTitle} />
              <span>{getTextByKey("hide-for-embed")}</span>
            </div>
          </div>
          <div className={`div-input ${invalidTitleForm ? "invalid" : ""}`}>
            <input
              id="form-title-input"
              onFocus={() => setFocusTitle(true)}
              onBlur={() => setBlurTitle(true)}
              value={formDisplayTitle}
              onChange={(e) => handleChangeTitleForm(e.target.value)}
              onPaste={handleTitlePaste}
              type="text"
              maxLength={MAX_LIMIT_TITLE}
            />
            {invalidTitleForm && (
              <div className="invalid-title-form">
                <span>{errorTitleText}</span>
              </div>
            )}
            <div className="max-chars">
              <span className="show-chars" style={{ direction: "ltr" }}>
                {formDisplayTitle.length} / {MAX_LIMIT_TITLE}
              </span>
            </div>
          </div>
        </div>
        <div className="div-input-description">
          <div className="div-text">
            <div className="tooltip-div">
              <label for="form-description-textarea" className="text-span">
                {getTextByKey("form-description")}
              </label>
              <Tooltip
                id={"form-description-tooltip"}
                tooltipTextKey="form-description-tooltip"
                //hardPositioned
              >
                <Icon name="question-circle" iconClass="tooltip-question" />
              </Tooltip>
            </div>
            <div className="toggle-div">
              <Toggle
                status={showDescription}
                setStatus={hideEmbedFormDescription}
              />
              <span>{getTextByKey("hide-for-embed")}</span>
            </div>
          </div>
          <div className={`div-input ${invalidDescription ? "invalid" : ""}`}>
            <textarea
              id="form-description-textarea"
              onFocus={(e) => setFocusDescription(e.target.value)}
              onBlur={(e) => setBlurDescription(e.target.value)}
              value={formDescription}
              onChange={(e) => handleChangeDescription(e.target.value)}
              onPaste={handleDescriptionPaste}
              maxLength={MAX_LIMIT_DESCRIPTION}
            />
            {invalidDescription && (
              <div className="invalid-description-form">
                <span>{errorDescriptionText}</span>
              </div>
            )}
            <div className="max-chars">
              <span className="show-chars" style={{ direction: "ltr" }}>
                {formDescription.length} / {MAX_LIMIT_DESCRIPTION}
              </span>
            </div>
          </div>
        </div>
        <div className="upload-form-image">
          <div className="image-text div-text">
            <div className="tooltip-div">
              <span className="text-span">{getTextByKey("form-image")}</span>{" "}
              <Tooltip
                id={"form-image-tooltip"}
                tooltipTextKey="form-image-tooltip"
                //hardPositioned
              >
                <Icon name="question-circle" iconClass="tooltip-question" />
              </Tooltip>
            </div>

            <div className="toggle-div">
              <Toggle status={showImage} setStatus={hideEmbedFormImage} />
              <span>{getTextByKey("hide-for-embed")}</span>
            </div>
          </div>
          <div className="upload-div" onClick={() => openUploadImageModal()}>
            <div className="hover-div">
              <div className="hover-text">
                <p>{getTextByKey("upload-image")}</p>
                <Image name="create-form/upload" alt="" title="" />
              </div>
            </div>
            <Image src={formImage} alt="" title="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormDetailsComponent;
